import { memo, useCallback } from 'react';
import { Box, Button, InfoImage } from '@betty/moonlight';
import { DepositNoPromoProps } from './DepositNoPromo.types';

function DepositNoPromo({ close, onConfirm }: DepositNoPromoProps) {
  const handleConfirm = useCallback(() => {
    close();
    onConfirm();
  }, [close, onConfirm]);

  return (
    <InfoImage
      titleNS="wallet"
      descriptionNS="wallet"
      titleKey="depositNoPromoConfirmationTitle"
      descriptionKey="depositNoPromoConfirmationDescription"
    >
      <Box flexDirection="row" gap="space-200">
        <Button
          flex={1}
          locNS="common"
          locKey="cancel"
          variant="secondary"
          onPress={close}
        />
        <Button
          flex={1}
          locNS="common"
          locKey="confirm"
          onPress={handleConfirm}
        />
      </Box>
    </InfoImage>
  );
}

export default memo(DepositNoPromo);
